import { useFormatShortDate as formatShortDate, useFormatTime as formatTime, } from '@coolblue-development/next-formatting-utils/client';
import { isTomorrow } from 'date-fns';
export const getTemporaryOutOfStockAvailability = ({ isPickupOnly, schedules, timeTravelOverride, t, logger, }) => {
    const now = timeTravelOverride ? new Date(timeTravelOverride) : new Date();
    const today = now.toISOString().split('T')[0];
    const todaySchedule = schedules.find(schedule => schedule.scheduleDate === today);
    if (!todaySchedule) {
        logger === null || logger === void 0 ? void 0 : logger.warning('No schedule found for today');
        return {
            description: '',
            promise: '',
        };
    }
    const pickupDay = formatShortDate(new Date(todaySchedule.nextPickupDateTime));
    const pickupTime = formatTime(new Date(todaySchedule.nextPickupDateTime));
    const isTomorrowPickupDay = isTomorrow(new Date(todaySchedule.nextPickupDateTime));
    let description;
    if (isPickupOnly) {
        description = t('notAvailableForPickup');
    }
    else {
        description = isTomorrowPickupDay
            ? t('temporaryOutOfStockPickupTomorrow', { pickupTime })
            : t('temporaryOutOfStockPickup', { pickupDay, pickupTime });
    }
    return {
        promise: t('temporaryOutOfStock'),
        description,
    };
};
//# sourceMappingURL=getTemporaryOutOfStockAvailability.js.map